/**
 * #293 — "Visualizar menu" com prévia do dono.
 *
 * O menu público está noutro site (pratzu.com/r/<slug>, <slug>.menu.pratzu.com)
 * e não vê a sessão do painel. Com o menu público pausado (trial vencido, sem
 * assinatura) o dono continua a poder pré-visualizar: o painel pede um token
 * de prévia (POST /admin/menu-preview) e abre o menu com `?preview=<token>`.
 * Com o menu no ar a API ignora a prévia (é o menu normal, sem faixa).
 */

export const PREVIEW_PARAM = 'preview'

/** URL do menu com o token de prévia (mantém path, query e hash). */
export function withPreview(url: string, token: string): string {
  const u = new URL(url)
  u.searchParams.set(PREVIEW_PARAM, token)
  return u.toString()
}

type Opener = {
  open: (url?: string, target?: string, features?: string) => WindowLike | null
}
type WindowLike = { opener: unknown; location: { href: string } }

/**
 * Abre o menu numa aba nova já com a prévia. A aba abre JÁ (dentro do clique,
 * para o bloqueador de pop-ups não a travar) e navega quando o token chega.
 * Sem token (rede, sessão expirada) abre o link normal: o menu público decide
 * (no ar → menu; pausado → página "indisponível"). Nunca falha em silêncio.
 */
export async function openMenuWithPreview(
  url: string,
  createToken: () => Promise<{ token: string }>,
  opener: Opener = window as unknown as Opener,
): Promise<string> {
  const tab = opener.open('about:blank', '_blank')
  let target = url
  try {
    target = withPreview(url, (await createToken()).token)
  } catch {
    /* sem prévia: link normal */
  }
  if (tab) {
    // a aba do menu não controla o painel (equivalente a rel=noopener)
    tab.opener = null
    tab.location.href = target
  } else {
    opener.open(target, '_blank', 'noopener,noreferrer')
  }
  return target
}
